import { render, staticRenderFns } from "./IfaceInfo.vue?vue&type=template&id=53067048&"
import script from "./IfaceInfo.vue?vue&type=script&lang=js&"
export * from "./IfaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports